var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#FFA14D",
    stroke: "#FFC285",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6453 7.54688H9.42793C9.26224 7.54688 9.12793 7.68119 9.12793 7.84688V16.7C9.12793 16.8657 9.26224 17 9.42793 17H10.6984C10.8643 17 10.9988 16.8653 10.9984 16.6994L10.9929 13.9128C10.9925 13.7469 11.127 13.6122 11.2929 13.6122H12.6018C13.2813 13.6122 13.8654 13.4859 14.3543 13.2331C14.8473 12.9763 15.2223 12.622 15.4791 12.1705C15.7401 11.7147 15.8706 11.1865 15.8706 10.5858C15.8706 9.98917 15.7443 9.46094 15.4916 9.00107C15.2388 8.54119 14.868 8.1849 14.3792 7.93217C13.8944 7.67531 13.3165 7.54688 12.6453 7.54688Z",
    fill: "#FFF8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3097 12.1085H10.9922V9.08203H12.3034C12.668 9.08203 12.9725 9.14418 13.217 9.26847C13.4656 9.38861 13.6499 9.56262 13.7701 9.79048C13.8902 10.0142 13.9503 10.2794 13.9503 10.5859C13.9503 10.8925 13.8902 11.1597 13.7701 11.3876C13.6499 11.6155 13.4656 11.7936 13.217 11.9221C12.9725 12.0463 12.6701 12.1085 12.3097 12.1085Z",
    fill: "#FFA14D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoint);
export default __webpack_public_path__ + "static/media/icon_point.ef717477ea89614ebff8f51fb29c3c25.svg";
export { ForwardRef as ReactComponent };